import React from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutFormBase from "./CheckoutForm";
import { STRIPE } from "@/config/appConfig";

const stripePromise = loadStripe(STRIPE);

type PaymentProps = {
  api?: (_data: unknown) => unknown;
  billingDetails?: unknown;
  data?: unknown;
  extraData?: unknown;
  success?: () => void;
};

const CheckoutForm = CheckoutFormBase as unknown as React.ComponentType<{
  api?: PaymentProps["api"];
  billingDetails?: unknown;
  data?: unknown;
  extraData?: unknown;
  success?: () => void;
}>;

const Payment = ({
  success,
  billingDetails,
  data,
  extraData,
  api,
}: PaymentProps) => {
  return (
    <Elements stripe={stripePromise}>
      <CheckoutForm
        success={success}
        billingDetails={billingDetails}
        data={data}
        extraData={extraData}
        api={api}
      />
    </Elements>
  );
};

export default Payment;
